export default {
    // 获取用户列表
    'getUserList':'/conference/userinfo/selectUserInfoPage',
    // 获取用户详情
    // 'getUserDetail':'/conference/userinfo/getUpdataCrUserInfoByUserId',
    // 编辑用户信息
    'editUserInfo':'/conference/userinfo/upDataUserInfoByUserId',
    // 删除用户
    'deleteUser':'/conference/userinfo/deleteSubuserUserInfo',
    // 停用 启用账户
    'changeUserStatus':'/conference/user/changeCrUserStatus',
}